var global = require('../internals/global');

module.exports = function (a, b) {
  var console = global.console;
  if (console && console.error) {
    arguments.length == 1 ? console.error(a) : console.error(a, b);
  }
};



// WEBPACK FOOTER //
// webpack://pdfmake/node_modules/core-js/internals/host-report-errors.js